/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Fetch, FlowInvocation } from '../../common/types/types';

interface ExtendFetchExpirationMutationProps {
    fetch?: Fetch;
    flowInvocation?: FlowInvocation;
    onView?: boolean;
}

export default class ExtendFetchExpirationMutation extends Relay.Mutation<ExtendFetchExpirationMutationProps> {

    static propTypes = {
        fetch: PropTypes.object,
        flowInvocation: PropTypes.object,
        onView: PropTypes.bool,
    };

    getMutation() {
        return Relay.QL`mutation {extendFetchExpiration}`;
    }

    getVariables() {
        return {
            fetch_id: this.props.fetch ? this.props.fetch.realId : null,
            flowInvocation_id: this.props.flowInvocation ? this.props.flowInvocation.realId : null,
            organisation_id: this.props.fetch ? this.props.fetch.organisation_id : (this.props.flowInvocation ? this.props.flowInvocation.organisation_id : null),
            onView: this.props.onView,
        };
    }

    // Use this method to design a ‘fat query’ – one that represents every
    // field in your data model that could change as a result of this mutation.
    // Liking a story could affect the likers count, the sentence that
    // summarizes who has liked a story, and the fact that the viewer likes the
    // story or not. Relay will intersect this query with a ‘tracked query’
    // that represents the data that your application actually uses, and
    // instruct the server to include only those fields in its response.
    getFatQuery() {
        return Relay.QL`
          fragment on ExtendFetchExpirationPayload {
            updatedNode {
                id,
                realId,
                expiresAt,
            }
          }
        `;
        }
    // These configurations advise Relay on how to handle the LikeStoryPayload
    // returned by the server. Here, we tell Relay to use the payload to
    // change the fields of a record it already has in the store. The
    // key-value pairs of ‘fieldIDs’ associate field names in the payload
    // with the ID of the record that we want updated.
    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
